import { fluidEcsClientConfiguration } from '../configuration';
import { EcsClientConfiguration, EcsSettingsProviderConfiguration } from '../interfaces';

/**
 * Object used to change the setup of a `EcsClient`.
 */
const defaultResponsesCacheKey = 'FluidEcsClientResponses';

/**
 * Gets the `EcsClientConfiguration` which contains information about how to connect to an ECS account
 * and information about the current request, like filters.
 * @param ecsSettingsProviderConfiguration Configuration for the EscSettingsProvider.
 * @returns An `EcsClientConfiguration` object used to setup an `EcsClient`
 */
export function getFluidEcsClientConfiguration(
  ecsSettingsProviderConfiguration: EcsSettingsProviderConfiguration
): EcsClientConfiguration {
  const userId = ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.id
    ? ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.id
    : ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.oid;
  const tenantId = ecsSettingsProviderConfiguration.ecsFilters.userContext.user?.tenantId;
  const hostName = ecsSettingsProviderConfiguration.hostName;
  const filters = { audience: ecsSettingsProviderConfiguration.ecsFilters.audience, userId, tenantId };
  const sessionId = ecsSettingsProviderConfiguration.sessionId;
  const cacheKey = `${userId}${hostName}${ecsSettingsProviderConfiguration.ecsFilters.audience}`;
  const responsesCacheKey = ecsSettingsProviderConfiguration.responsesCacheKeyOverride || defaultResponsesCacheKey;
  const cacheExpiresDurationOverrideInMin = ecsSettingsProviderConfiguration.cacheExpiresDurationOverrideInMin;

  return {
    ...fluidEcsClientConfiguration,
    filters,
    cacheKey,
    responsesCacheKey,
    cacheExpiresDurationOverrideInMin,
    sessionId
  };
}
